import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pedal-filters" }

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { usePedalStore } from '@/store/pedalStore'
import FilterSummary from '@/components/setup/FilterSummary.vue'
import FilterSummaryItem from '@/components/setup/FilterSummaryItem.vue'
import CommonFilterAccordion from '@/components/setup/common/CommonFilterAccordion.vue'
import CommonSliderFilter from '@/components/setup/common/CommonSliderFilter.vue'
import { CommonSliderFilterType } from '@/types/filter'


export default /*@__PURE__*/_defineComponent({
  __name: 'PedalFilters',
  setup(__props) {

const { t } = useI18n()

const userStore = useUserStore()
const { sessionId } = storeToRefs(userStore)

const pedalStore = usePedalStore()
const { filters } = storeToRefs(pedalStore)

const loading = ref(false)

const stackSummary = ref()

const pedalStackFilter: CommonSliderFilterType = {
  value: {
    Stack: filters.value.Stack ?? 0,
  },
  min: {
    MinStack: 0,
  },
  max: {
    MaxStack: 40,
  },
}

const search = (e?: Record<string, any>) => {
  pedalStore.reset()

  if (e) pedalStore.setFilters(e)

  pedalStore.retrievePedals(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_unref(t)('common.properties')), 1),
    _createVNode(CommonFilterAccordion, {
      title: _unref(t)('setup.pedal.stack'),
      icon: "/icons/filters/pedal__stack.svg"
    }, {
      default: _withCtx(() => [
        _createVNode(CommonSliderFilter, {
          unit: _unref(t)('common.unit.mm'),
          "summary-prefix": _unref(t)('setup.pedal.stack'),
          filter: pedalStackFilter,
          onUpdated: _cache[0] || (_cache[0] = ($event: any) => (search($event))),
          onSummary: _cache[1] || (_cache[1] = ($event: any) => (stackSummary.value = $event))
        }, null, 8, ["unit", "summary-prefix"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(FilterSummary, null, {
      default: _withCtx(() => [
        (stackSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(stackSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})